module.exports = __webpack_public_path__ + "static/media/no_user_ranking.aa3fdc3a.jpg";